export default Object.freeze({
  Or: 0,
  And: 1,
});
